import React from 'react'
import { Image } from '../BlockLibrary/Common/Image'
import { RichText } from '../richTextOptions'
import { addSlashToStr } from '../utilities';

const ContentfulBlockPetCard = (card) => {
	const cardClass = `pet-card ${card.cardClassName ? card.cardClassName.toLowerCase().replace(/ /g, '-') : ''}`;

	const DefaultCardContent = () => (
		<>
			<div className="pet-card-content">
				<div className="pet-card-header">
					{card.cardHeader && <span>{card.cardHeader}</span>}
				</div>
				<div className="pet-card-text">
					{card.cardText && <p>{card.cardText}</p>}
					{card.cardRichText && <RichText data={card.cardRichText} />}
				</div>
			</div>
			<div className="pet-card-image">
				<Image image={card.image} />
			</div>
		</>
	)

	const TitleAndImageTopCardContent = () => (
		<>
			<div className="pet-card-image-title">
				<Image image={card.image} />
				{card.cardHeader && <span>{card.cardHeader}</span>}
			</div>
			<div className="pet-card-content">
				{card.cardText && <p>{card.cardText}</p>}
				{card.cardRichText && <RichText data={card.cardRichText} />}
			</div>

		</>
	)

	const getCardContent = () => {
		switch (card.cardTemplate) {
			case 'Title and Image Top':
				return <TitleAndImageTopCardContent />;
			default:
				return <DefaultCardContent />
		}
	}

	return (
		<>
			{
				card.link ? (
					<a className={cardClass} href={addSlashToStr(card.link)} target={card.targetLink === 'New Tab' ? '_blank' : '_self'}>
						{getCardContent()}
					</a>

				) : (
					<div className={cardClass}>
						{getCardContent()}
					</div>
				)
			}
		</>
	)
}

export { ContentfulBlockPetCard }
